/* eslint-disable max-len */
import 'react';

const SidebarBookPublicSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="知识本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="编组-16" transform="translate(3.000000, 1.500000)">
                    <path d="M1.4,4.5 L9,4.5 C10.6568542,4.5 12,5.84314575 12,7.5 L12,12.4 C12,13.559798 11.059798,14.5 9.9,14.5 L2.1,14.5 C0.940202025,14.5 1.10117726e-15,13.559798 0,12.4 L0,5.9 C-3.1673413e-16,5.12680135 0.62680135,4.5 1.4,4.5 Z" id="矩形" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="0,0" fillRule="nonzero"></path>
                    <path d="M3,4 L3,3 C3,1.34314575 4.34314575,0 6,0 C7.65685425,0 9,1.34314575 9,3 L9,4 L9,4" id="形状" stroke="currentcolor" strokeLinecap="round"></path>
                    <g id="编组-18" transform="translate(3.000000, 7.500000)" fill="currentcolor">
                        <path d="M3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.36968103 3.79940038,1.69250951 3.5011143,1.86557226 L3.5,3.5 C3.5,3.77614237 3.27614237,4 3,4 C2.72385763,4 2.5,3.77614237 2.5,3.5 L2.4998705,1.86614288 C2.20104123,1.69321974 2,1.37008772 2,1 C2,0.44771525 2.44771525,0 3,0 Z" id="形状结合"></path>
                    </g>
                </g>
            </g>
        </svg>);
};
export default SidebarBookPublicSvg;
